import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}
  /**
   * @description
   * Checks if the user is authenticated by checking if the 'jwttoken' is present in the session storage.
   * If the token is present, the guard allows the user to navigate to the requested route.
   * If the token is not present, the guard redirects the user to the home page and prevents the navigation to the requested route.
   * @param route The route that the user is trying to navigate to.
   * @param state The state of the router.
   * @returns A boolean indicating if the navigation to the requested route is allowed.
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Check if the user is authenticated by checking if the 'jwttoken' is present in the session storage.
    if (sessionStorage.getItem('jwttoken') != null) {
      // If the token is present, allow the navigation to the requested route.
      return true;
    } else {
      // If the token is not present, redirect the user to the home page and prevent the navigation to the requested route.
      this.router.navigateByUrl('/home');
      return false;
    }
  }
}
